import React from 'react'
import { View, StyleSheet } from '@react-pdf/renderer'

const styles = StyleSheet.create({
    grid: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingRight: 2,
        height: '100%',
        position: 'relative',
    },
    gridLast: {
        height: '90%',
        borderRightWidth: 0,
        borderRightStyle: 'solid',
        borderRightColor: 'rgb(204,214,228)',
    }
});

const initialValue = 1;
const endValue = 4;
const finalArray = [];

for (let n = initialValue; n <= endValue; n += 1) {
    finalArray.push({ label: n });
}

const TableGridPulse = () => {
    return (
        <View style={styles.grid}>
            {finalArray.map((item, index) => {
                return (
                    <View
                        key={index}
                        style={{
                            width: '20%',
                            height: '90%',
                            borderLeftStyle: 'solid',
                            borderLeftColor: 'rgb(204,214,228)',
                            borderLeftWidth: index === 0 ? 0 : 1,
                        }}
                    ></View>
                );
            })}
            <View style={styles.gridLast}></View>
        </View>
    )
}

export default TableGridPulse